import {ResumoNgrx} from '~model/ngrx/resumo-ngrx';
import {Action, createReducer, on} from '@ngrx/store';
import {
  resumoReiniciar,
  resumoSetAtendimentos,
  resumoSetCaminhoesUtilizados,
  resumoSetClientesAtendidos,
  resumoSetDistanciaRoterizada,
  resumoSetPedidosNaoAtendidos,
  resumoSetRotasGeradas,
} from './feature-resumo.actions';
import {PlanejadoExecutado} from '~utils/planejado-executado';

const initial = (): PlanejadoExecutado => ({planejado: 0, executado: 0});

const initialState: ResumoNgrx = {
  atendimentosRealizados: initial(),
  caminhoesUtilizados: initial(),
  clientesAtendidos: initial(),
  distanciaRoterizada: initial(),
  pedidosNaoAtendidos: initial(),
  rotasGeradas: initial(),
};

const reducer = createReducer(
  initialState,
  on(resumoSetDistanciaRoterizada, (state, action: PlanejadoExecutado) => ({...state, distanciaRoterizada: action})),
  on(resumoSetRotasGeradas, (state, action: PlanejadoExecutado) => ({...state, rotasGeradas: action})),
  on(resumoSetAtendimentos, (state, action: PlanejadoExecutado) => ({...state, atendimentosRealizados: action})),
  on(resumoSetClientesAtendidos, (state, action: PlanejadoExecutado) => ({...state, clientesAtendidos: action})),
  on(resumoSetCaminhoesUtilizados, (state, action: PlanejadoExecutado) => ({...state, caminhoesUtilizados: action})),
  on(resumoSetPedidosNaoAtendidos, (state, action: PlanejadoExecutado) => ({...state, pedidosNaoAtendidos: action})),
  on(resumoReiniciar, () => (initialState))
);

export const featureResumoReducer = (state: ResumoNgrx, action: Action) => reducer(state, action);

